<template>
    <div ref="base-print-qrcode" class="base-print-qrcode">
        <div class="left">
            <base-qrcode
				:width="width"
				:height="height"
				:url="url"
				style="margin-bottom: 10px;"></base-qrcode>
        </div>
        <div class="right">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import baseQrcode from './base-qrcode.vue';
    import { createIframePrint } from "src/common/print";
    export default {
        name: 'base-print-qrcode',
        components: {
            baseQrcode
        },
        props: {
            url: {
                type: String,
                default: null
			},
			width: {
                type: Number,
                default: 100
            },
            height: {
                type: Number,
                default: 100
            }
        },
        mounted() {
        },
        methods: {
            handlePrint() {
                const ele = this.$refs['base-print-qrcode'];
                this.isPrint = true;
                setTimeout(() => {
                    createIframePrint(ele, { useCORS: true, logging: true }, false).then(() => {
                        this.isPrint = false;
                    });
                }, 300);
            }
        },
        data() {
            return {
                isPrint: false
            }
        }
    }
</script>

<style lang="scss">
    @import 'src/sass/modules/mixin';
    .base-print-qrcode{
        & > .left{
            margin-right: 10px;
        }
        @include flex_center(flex-start, flex-start);
        height: 100%;
        width: 100%;
    }
</style>
